export default "__VITE_ASSET__DjD6hIu4__"